export default "__VITE_ASSET__ClhdKII8__"